function getExplorerInfo() {
  const ua = navigator.userAgent.toLowerCase(); //获取用户端信息
  const info = {
    ie: /msie/.test(ua) && !/opera/.test(ua),
    //匹配IE浏览器
    opera: /opera/.test(ua),
    //匹配Opera浏览器
    safari: /version.*safari/.test(ua),
    //匹配Safari浏览器
    chrome: /chrome/.test(ua),
    //匹配Chrome浏览器
    firefox: /gecko/.test(ua) && !/webkit/.test(ua) //匹配Firefox浏览器
  };
  return info;
}
export default getExplorerInfo;